module.exports = __webpack_public_path__ + "img/left-img.3e4beab7.png";